<template>
    <fragment>
        <div class="col-3" v-for="(v,index) in value">
             <phone v-model="value[index]" @add-entity="add" @remove-entity="removeEntity" :index="index" :readOnly="readonly" :first="index==0" :last="index==value.length-1"></phone>
        </div>
        </fragment>
</template>
<script>
    import axios from 'axios';
  export default {
        name: 'phonelist',
       
        props: {
            readonly: {
                type: Boolean,
                required: false,
                default:() => false
            },
            value: {
                type: Array,
                required: false
            }
        },
        data() {
            return {
                entityType: 'phone'
            }

        },
        components: {
           
        },
        methods: {
           
            add() {
                var me = this;
                axios.get('utility/new/' + me.entityType).then(response => {
                    me.value.push(response.data);

                });
            }
            , removeEntity(v) {
              
                var me = this;
                var delIndex = -1;
               for (var i = 0; i < this.value.length; i++) {
                    if (this.value[i].phoneId != v.phoneId) {
                        delIndex = i;
                        break;
                        }
                }
                if (delIndex >= 0) {
                    this.value.splice(delIndex, 1);
                }
            }
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
